import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { useLazyGetPortfolioDetailsQuery } from "../../service/portfolio";
import { showError } from "../../constants/toasts";
import Loader from "../../constants/Loader";
import dayjs from "dayjs";

const ViewPortfolio = () => {
  const navigate = useNavigate();
  const { id } = useParams();

  const [portfolio, setPortfolio] = useState<any>(null);
  const [getPortfolioDetails, { isLoading }] = useLazyGetPortfolioDetailsQuery();

  const getPortfolioDetailsApi = async () => {
    try {
      const response = await getPortfolioDetails({
        id,
      }).unwrap();
      if (response.statusCode === 200) {
        setPortfolio(response?.data);
      }
    } catch (error: any) {
      showError(error?.data?.message || "");
    }
  };

  useEffect(() => {
    if (id) {
      getPortfolioDetailsApi();
    }
  }, [id]);

  return (
    <>
      <Loader isLoad={isLoading} />
      <div className="main_title">
        <h1>Portfolio Details</h1>
        <p>
          <button onClick={() => navigate("/dashboard")}>Dashboard</button> -{" "}
          <button onClick={() => navigate("/portfolio")}>Portfolio Management</button> -
          Portfolio Detail
        </p>
      </div>

      <div className="cards view_page">
        <div className="gap_p">
          <div className="w_33">
            <h6>Service Name:</h6>
            <p>{portfolio?.name || "-"}</p>
          </div>
          <div className="w_33">
            <h6>Description:</h6>
            <p>{portfolio?.description || "-"}</p>
          </div>
          <div className="w_33">
            <h6>Category</h6>
            <p>{portfolio?.category?.name || "-"}</p>
          </div>
          <div className="w_33">
            <h6>Sub-category</h6>
            <p>{portfolio?.subCategory?.name || "-"}</p>
          </div>
          <div className="w_33">
            <h6>Date of Completion</h6>
            <p>{portfolio?.date ? dayjs(portfolio?.date).format("DD MMMM YYYY") : "-"}</p>
          </div>

          <div className="w_100">
            <h6>Media</h6>
            <div className="gap_p" style={{ marginTop: "10px" }}>
              {(portfolio?.media?.length ?? 0) > 0 ? (
                portfolio?.media?.map((media: any, index: number) => {
                  if (String(media.type) === "1") {
                    return (
                      <div className="w_33" key={index} style={{ marginBottom: "16px" }}>
                        <figure style={{ margin: 0, overflow: "hidden", borderRadius: "8px" }}>
                          <img
                            src={media?.url}
                            alt={`Portfolio ${index + 1}`}
                            style={{ width: "100%", height: "200px", objectFit: "cover" }}
                          />
                        </figure>
                      </div>
                    );
                  } else if (String(media.type) === "2") {
                    return (
                      <div className="w_33" key={index} style={{ marginBottom: "16px" }}>
                        <video
                          width="100%"
                          height="200"
                          controls
                          style={{ borderRadius: "8px", objectFit: "cover" }}
                        >
                          <source src={media?.url} type="video/mp4" />
                          <track kind="captions" label="Captions" default />
                        </video>
                      </div>
                    );
                  }
                  return null;
                })
              ) : (
                <p>No media available</p>
              )}
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default ViewPortfolio;
